import { T } from "@repo/transifex";
import { Spinner } from "~/components/assets/spinner";

import { Modal, type ModalProps } from "../shared/modal";
import { ModalTitle } from "../shared/modal-title";

type ModalLoadingGenericProps = Pick<ModalProps, "open">;

export const ModalLoadingGeneric = ({
  open = true
}: ModalLoadingGenericProps) => {
  return (
    <Modal open={open} backdropVariant="idle">
      <div className="flex flex-col items-center gap-y-16">
        <Spinner className="!text-kiosk-accent-primary" />

        <ModalTitle size="9xl" weight="bold" variant="info">
          <T _str="Loading..." />
        </ModalTitle>

        <p className="text-6xl font-extralight text-kiosk-accent-primary">
          <T _str="Please wait" />
        </p>
      </div>
    </Modal>
  );
};
